import {graphql} from 'gatsby'
import React, {useEffect, useState} from 'react'
import ColumnBackAndForth from '../../../components/atoms/columnBackAndForth'
import SEO from '../../../components/atoms/seo'
import {ITopicPath} from '../../../components/atoms/topicPath'
import ColumnAuthor002 from '../../../components/molecules/columnAuthor002'
import ColumnDetailInner0039 from '../../../components/molecules/columnDetailInner0039'
import ColumnRelationCards0039 from '../../../components/molecules/columnRelationCards0039'
import UsefulFunctionLayout017 from '../../../components/molecules/usefulFunctionLayout017'
import ColumnDetailsBody from '../../../components/organisms/columnDetailsBody'
import ColumnLayout from '../../../components/organisms/columnLayout'
import Conclusion001 from '../../../components/molecules/Conclusion001'
import Conclusion004 from '../../../components/molecules/Conclusion004'
import Conclusion007 from '../../../components/molecules/Conclusion007'
import Conclusion002 from '../../../components/molecules/Conclusion002'
import Conclusion005 from '../../../components/molecules/Conclusion005'
import Conclusion008 from '../../../components/molecules/Conclusion008'
import Conclusion003 from '../../../components/molecules/Conclusion003'
import Conclusion006 from '../../../components/molecules/Conclusion006'
import Conclusion009 from '../../../components/molecules/Conclusion009'
import PopupBanner from '../../../components/molecules/popupBanner'
import CarouselBanner from '../../../components/molecules/carouselBanner'
import useRouteParam from '../../../hooks/useRouteParam'

/**
 * コラム記事詳細画面
 * @constructor
 */
const C0039 = () => {
  const paths: ITopicPath[] = [
    { title: 'キンクラコラムTOP', link: useRouteParam('/column') },
    { title: 'コラム記事一覧', link: useRouteParam('/column/list') },
    {
      title:
        '育児と仕事の両立サポート制度「育児短時間勤務」「育児時間」とはどのような制度？',
    },
  ]
  // 0~8ランダム数字を保存
  const [no, setNo] = useState(-1)
  useEffect(() => {
    setNo(Math.floor(Math.random() * 9))
  }, [])

  return (
    <ColumnLayout paths={paths}>
      <SEO
        title="「育児短時間勤務（時短）」「育児時間」とは？制度を解説します"
        description="育児と仕事を両立するための制度のうち、比較的幼い子を育てる労働者向けの制度である「短時間勤務制度」と「育児時間」について詳しく解説します。"
        ogUrl="https://kintaicloud.jp/column/details/C0039/"
        ogType="article"
        ogTitle="「育児短時間勤務（時短）」「育児時間」とは？制度を解説します"
        ogDescription="育児と仕事を両立するための制度のうち、比較的幼い子を育てる労働者向けの制度である「短時間勤務制度」と「育児時間」について詳しく解説します。"
        ogSiteName="キンクラ - 客先常駐特化型のクラウド勤怠管理システム"
        ogImage="https://www.kintaicloud.jp/images/column/details/c0039.jpg"
      />
      <ColumnDetailsBody>
        {/** ポップアップバナー */}
        <PopupBanner />
        {/** 記事本体 */}
        <ColumnDetailInner0039 no={no} />
        {/** オーサ情報 */}
        <ColumnAuthor002 />
        {/** ここに9パターンの広告設定する */}
        {no === 0 && <Conclusion001 />}
        {no === 1 && <Conclusion002 />}
        {no === 2 && <Conclusion003 />}
        {no === 3 && <Conclusion004 />}
        {no === 4 && <Conclusion005 />}
        {no === 5 && <Conclusion006 />}
        {no === 6 && <Conclusion007 />}
        {no === 7 && <Conclusion008 />}
        {no === 8 && <Conclusion009 />}
        {/** お役立ち機能 */}
        <UsefulFunctionLayout017 />
        {/** 前後記事への遷移 */}
        <ColumnBackAndForth />
        {/** カルーセルバナー */}
        <CarouselBanner />
        {/** 関連記事 */}
        <ColumnRelationCards0039 />
      </ColumnDetailsBody>
    </ColumnLayout>
  )
}

export default C0039

export const pageQuery = graphql`
  query C0039 {
    site {
      siteMetadata {
        title
      }
    }
  }
`
